import { render, staticRenderFns } from "./XtendAlertsMetaDetails.vue?vue&type=template&id=18323b66&"
import script from "./XtendAlertsMetaDetails.vue?vue&type=script&lang=js&"
export * from "./XtendAlertsMetaDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports